const {createSlice} = require("@reduxjs/toolkit");
const flightDelete = createSlice({
  name: "flightDelete",
  initialState: {
    loading: false,
    selectedId: null
  },
  reducers:{
    deleteFlightAction(state, action){
      return {
        ...state,
        loading: true
      }
    },
    setDeleteFlightLoadingAction(state, action) {
      return {
        ...state,
        loading: false
      }
    },
    setDeleteFlightSelectedIdAction(state, action){
      return{
        ...state,
        selectedId: action.payload.id
      }
    }
  }
})

export const {deleteFlightAction, setDeleteFlightLoadingAction, setDeleteFlightSelectedIdAction} = flightDelete.actions
export default flightDelete.reducer